/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router";
import { Button } from "reactstrap";
import Breadcrumb from "../../../components/common/breadcrumb";
import { getCourseById } from "../../../services/labServices";
import CourseMacroData from "../../../components/course/courseMacroData";
import Categories from "../../../components/course/courseCategories";
import CourseUnitsAndComponents from "../../../components/course/courseUnitsAndComponents";
import { useAuth } from "../../../context/AuthContext";
import modulos from "../../../mocks/modulos";

const NewCourse = ({ history }) => {
  const { id } = useParams();
  const { currentUser } = useAuth();
  const isAudit = currentUser.haveAuditAccess(modulos.LAB);
  const [currentCourse, setCurrentCourse] = useState({});
  const [readOnly, setReadOnly] = useState(false);

  useEffect(async () => {
    if (id) {
      const res = await getCourseById(id);
      const course = res.result.rows[0];
      setCurrentCourse(course);
      if (course.enrolleds || isAudit) {
        setReadOnly(true);
      }
    }
  }, [id]);

  const handleBackButton = () => {
    history.push("/courses");
  };

  const handleFinish = async () => {
    history.push(`/courses/new/${id}/preview`);
  };
  return (
    <>
      <Helmet>
        <title>PIN - Back Office Lab</title>
      </Helmet>
      <Breadcrumb
        title="Nuevo curso"
        currentLevel={currentCourse ? currentCourse.title : "Nuevo curso"}
        parent="Back Office lab"
        backButton
        onBackButton={handleBackButton}
      />
      {readOnly && (
        <div className="alert alert-danger" role="alert">
          {isAudit ? "No puede modificar este curso" : "No se puede modificar este curso, tiene alumno inscritos"}
        </div>
      )}
      <div className="container-fluid">
        <CourseMacroData course={currentCourse} readOnly={readOnly} />
      </div>
      <div className="container-fluid" style={{ position: "relative", zIndex: 10 }}>
        <Categories course={currentCourse} readOnly={readOnly} />
      </div>
      <div className="container-fluid" style={{ position: "relative", zIndex: 5 }}>
        <CourseUnitsAndComponents course={currentCourse} readOnly={readOnly} />
      </div>
      <div className="container-fluid mb-3" style={{ position: "relative", zIndex: 0 }}>
        <div className="row">
          <div className="col-12 d-flex justify-content-end">
            <Button className="btn-success" color="primary" type="button" onClick={handleFinish} disabled={!currentCourse.id}>
              Finalizar
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(NewCourse);
